module.exports = __webpack_public_path__ + "img/blowfish.452f591c.png";